import type { OptionKV } from "~styled/selector/Selector";

export enum EEstadoPoliza {
  Vigente = "Vigente",
  EmitidaNoVigente = "EmitidaNoVigente",
  Vencida = "Vencida",
  Anulada = "Anulada",
}

const TODOS = "";
export const VIGENTE = EEstadoPoliza.Vigente;
export const EMITIDANOVIGENTE = EEstadoPoliza.EmitidaNoVigente;
export const VENCIDA = EEstadoPoliza.Vencida;
export const ANULADA = EEstadoPoliza.Anulada;

const estadosPolizasOptions: Record<EEstadoPoliza | typeof TODOS, string> = {
  [TODOS]: "Todos",
  [VIGENTE]: "Vigente",
  [EMITIDANOVIGENTE]: "Emitida No Vigente",
  [VENCIDA]: "Vencida",
  [ANULADA]: "Anulada",
};

const estadosPolizasFilter: OptionKV<EEstadoPoliza | typeof TODOS>[] = [
  { label: estadosPolizasOptions[TODOS], value: TODOS },
  { label: estadosPolizasOptions[VIGENTE], value: VIGENTE },
  { label: estadosPolizasOptions[EMITIDANOVIGENTE], value: EMITIDANOVIGENTE },
  { label: estadosPolizasOptions[VENCIDA], value: VENCIDA },
  { label: estadosPolizasOptions[ANULADA], value: ANULADA },
];

export { estadosPolizasOptions, estadosPolizasFilter };
